module.exports = __webpack_public_path__ + "static/img/v2_poster.0edf26b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fundingnew_/detail/jolin/1/v2_poster.jpg
// module id = bF5K
// module chunks = 1